import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hoverLgreyBg pad10",
  style: `border-bottom: 1px solid #efefef; `
}
const _hoisted_2 = { class: "fw600 mt6" }
const _hoisted_3 = {
  class: "fs12 greyColor mr20 mt5",
  style: {"line-height":"12px"}
}
const _hoisted_4 = { class: "fs16 fw600 pointer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { class: "grey fs12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, " 編集", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.tmp)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "fl pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectTmp && _ctx.selectTmp(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.tmp.public_id), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tmp.title), 1)
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.truncate(_ctx.tmp.content, 20)), 1),
            _hoisted_7
          ]),
          (_ctx.showDeleteButton)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                width: "22",
                height: "25",
                class: "fr pointer mr10 mt10",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteTmp && _ctx.deleteTmp(...args)))
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.showEditButton)
            ? (_openBlock(), _createElementBlock("label", {
                key: 1,
                class: _normalizeClass(`circle_button fw400 fr centered fs12 blueAround`),
                style: {"width":"80px","padding":"4px 10px","margin-right":"10px","margin-top":"8px"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editTmp && _ctx.editTmp(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                  width: "14",
                  height: "14",
                  style: {"margin-top":"-2px"}
                }, null, 8, _hoisted_9),
                _hoisted_10
              ]))
            : _createCommentVNode("", true),
          _hoisted_11
        ]),
        _hoisted_12
      ]))
    : _createCommentVNode("", true)
}